import { AxiosProgressEvent } from 'axios';

import { ApiErrorData, ApiResponse } from 'models/ApiResponse';
import { Contact } from 'models/Contact';

import { FunctionsHelper } from 'utils/FunctionsHelper';

import MainBackendAxios from '../utils/MainBackendAxios';

export const ContactService = {
  getAvailableByCurrentCompany: async (): Promise<
    ApiResponse<Contact[] | ApiErrorData>
  > => {
    try {
      const response = await MainBackendAxios.get(
        `/contact/get-available-by-current-company`
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  getAll: async (): Promise<ApiResponse<Contact[] | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.get(`/contact/get-all`);

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  findById: async (
    id: number
  ): Promise<ApiResponse<Contact | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.get(`/contact/find-by-id/${id}`);

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  create: async (
    params: CreateContactRequestDto
  ): Promise<ApiResponse<{ createdId: number } | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.post(`/contact/create`, params);

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  update: async (
    id: number,
    params: UpdateContactRequestDto
  ): Promise<ApiResponse<{ executedAction: boolean } | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.put(
        `/contact/update/${id}`,
        params
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  delete: async (
    id: number
  ): Promise<ApiResponse<{ executedAction: boolean } | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.delete(`/contact/delete/${id}`);

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  uploadAvatarFile: async (
    formData: FormData,
    onProgress?: (progressEvent: AxiosProgressEvent) => void
  ): Promise<ApiResponse<{ url: string } | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.post(
        `/contact/upload-avatar-file`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: onProgress,
        }
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  uploadPositions: async (
    ids: number[]
  ): Promise<ApiResponse<{ rowsUpdated: number } | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.post(
        `/contact/update-positions`,
        { ids }
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
};

interface CreateContactRequestDto {
  companyIds: number[];
  countryCode: string;
  fullName: string;
  position: string;
  dialCode: string;
  phone: string;
  email: string;
  avatarUrl: string;
  description: string | null;
}

interface UpdateContactRequestDto {
  companyIds: number[];
  fullName: string;
  position: string;
  dialCode: string;
  phone: string;
  email: string;
  avatarUrl: string;
  description: string | null;
}
